// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3D0eG","buttons":"Footer_buttons__2hXlV"};